import $3T2N1$intlcalendararAEmjs from "../intl/calendar/ar-AE.mjs";
import $3T2N1$intlcalendarbgBGmjs from "../intl/calendar/bg-BG.mjs";
import $3T2N1$intlcalendarcsCZmjs from "../intl/calendar/cs-CZ.mjs";
import $3T2N1$intlcalendardaDKmjs from "../intl/calendar/da-DK.mjs";
import $3T2N1$intlcalendardeDEmjs from "../intl/calendar/de-DE.mjs";
import $3T2N1$intlcalendarelGRmjs from "../intl/calendar/el-GR.mjs";
import $3T2N1$intlcalendarenUSmjs from "../intl/calendar/en-US.mjs";
import $3T2N1$intlcalendaresESmjs from "../intl/calendar/es-ES.mjs";
import $3T2N1$intlcalendaretEEmjs from "../intl/calendar/et-EE.mjs";
import $3T2N1$intlcalendarfiFImjs from "../intl/calendar/fi-FI.mjs";
import $3T2N1$intlcalendarfrFRmjs from "../intl/calendar/fr-FR.mjs";
import $3T2N1$intlcalendarheILmjs from "../intl/calendar/he-IL.mjs";
import $3T2N1$intlcalendarhrHRmjs from "../intl/calendar/hr-HR.mjs";
import $3T2N1$intlcalendarhuHUmjs from "../intl/calendar/hu-HU.mjs";
import $3T2N1$intlcalendaritITmjs from "../intl/calendar/it-IT.mjs";
import $3T2N1$intlcalendarjaJPmjs from "../intl/calendar/ja-JP.mjs";
import $3T2N1$intlcalendarkoKRmjs from "../intl/calendar/ko-KR.mjs";
import $3T2N1$intlcalendarltLTmjs from "../intl/calendar/lt-LT.mjs";
import $3T2N1$intlcalendarlvLVmjs from "../intl/calendar/lv-LV.mjs";
import $3T2N1$intlcalendarnbNOmjs from "../intl/calendar/nb-NO.mjs";
import $3T2N1$intlcalendarnlNLmjs from "../intl/calendar/nl-NL.mjs";
import $3T2N1$intlcalendarplPLmjs from "../intl/calendar/pl-PL.mjs";
import $3T2N1$intlcalendarptBRmjs from "../intl/calendar/pt-BR.mjs";
import $3T2N1$intlcalendarptPTmjs from "../intl/calendar/pt-PT.mjs";
import $3T2N1$intlcalendarroROmjs from "../intl/calendar/ro-RO.mjs";
import $3T2N1$intlcalendarruRUmjs from "../intl/calendar/ru-RU.mjs";
import $3T2N1$intlcalendarskSKmjs from "../intl/calendar/sk-SK.mjs";
import $3T2N1$intlcalendarslSImjs from "../intl/calendar/sl-SI.mjs";
import $3T2N1$intlcalendarsrSPmjs from "../intl/calendar/sr-SP.mjs";
import $3T2N1$intlcalendarsvSEmjs from "../intl/calendar/sv-SE.mjs";
import $3T2N1$intlcalendartrTRmjs from "../intl/calendar/tr-TR.mjs";
import $3T2N1$intlcalendarukUAmjs from "../intl/calendar/uk-UA.mjs";
import $3T2N1$intlcalendarzhCNmjs from "../intl/calendar/zh-CN.mjs";
import $3T2N1$intlcalendarzhTWmjs from "../intl/calendar/zh-TW.mjs";

var $e05239aa7a8d905d$exports = {};


































$e05239aa7a8d905d$exports = {
    "ar-AE": $3T2N1$intlcalendararAEmjs,
    "bg-BG": $3T2N1$intlcalendarbgBGmjs,
    "cs-CZ": $3T2N1$intlcalendarcsCZmjs,
    "da-DK": $3T2N1$intlcalendardaDKmjs,
    "de-DE": $3T2N1$intlcalendardeDEmjs,
    "el-GR": $3T2N1$intlcalendarelGRmjs,
    "en-US": $3T2N1$intlcalendarenUSmjs,
    "es-ES": $3T2N1$intlcalendaresESmjs,
    "et-EE": $3T2N1$intlcalendaretEEmjs,
    "fi-FI": $3T2N1$intlcalendarfiFImjs,
    "fr-FR": $3T2N1$intlcalendarfrFRmjs,
    "he-IL": $3T2N1$intlcalendarheILmjs,
    "hr-HR": $3T2N1$intlcalendarhrHRmjs,
    "hu-HU": $3T2N1$intlcalendarhuHUmjs,
    "it-IT": $3T2N1$intlcalendaritITmjs,
    "ja-JP": $3T2N1$intlcalendarjaJPmjs,
    "ko-KR": $3T2N1$intlcalendarkoKRmjs,
    "lt-LT": $3T2N1$intlcalendarltLTmjs,
    "lv-LV": $3T2N1$intlcalendarlvLVmjs,
    "nb-NO": $3T2N1$intlcalendarnbNOmjs,
    "nl-NL": $3T2N1$intlcalendarnlNLmjs,
    "pl-PL": $3T2N1$intlcalendarplPLmjs,
    "pt-BR": $3T2N1$intlcalendarptBRmjs,
    "pt-PT": $3T2N1$intlcalendarptPTmjs,
    "ro-RO": $3T2N1$intlcalendarroROmjs,
    "ru-RU": $3T2N1$intlcalendarruRUmjs,
    "sk-SK": $3T2N1$intlcalendarskSKmjs,
    "sl-SI": $3T2N1$intlcalendarslSImjs,
    "sr-SP": $3T2N1$intlcalendarsrSPmjs,
    "sv-SE": $3T2N1$intlcalendarsvSEmjs,
    "tr-TR": $3T2N1$intlcalendartrTRmjs,
    "uk-UA": $3T2N1$intlcalendarukUAmjs,
    "zh-CN": $3T2N1$intlcalendarzhCNmjs,
    "zh-TW": $3T2N1$intlcalendarzhTWmjs
};


export {$e05239aa7a8d905d$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
